module.exports = __webpack_public_path__ + "static/media/sg.069ac740.webp";